/* 
  This utilities are needed for converting 
  getQueryStringFromUrl - use it to convert url to QueryString. 
  stringifyQuery - converts Object to QueryString using qs.
  parseQuery - converts QueryString to Query Object. Uses qs and a lot of fixes*. 
  * - main pains is to convert boolean, integer etc from strings to appropriate types. 
    this requires a knowledge of Prisma 'modelDefinition', which fields are which types. 
    but we will use a shortcuts based on our conventions (se fixQueryWhere function): 
      boolean - when toSting is true, false or null
      integer - when field name is 'id' or contains 'count_' ot '_id'
      float
      string, text - should be fine, since text is a default.

    questions: 
      what about 'null'
*/ 
const qs = require('qs');


export const DEFAULT_QUERY_LIMIT = 5  // default limit which will be used in all queries 


export const getQueryStringFromUrl = (url) => {
  return url?.split('?')?.[1]  // takes everything after '?'. We will work with this kind of  
  // const query = req.query  // don't use it, since prisma query will not be properely converted 
  // example url: http://localhost:3000/api/apps?where[id]=19&select[email]=true&select[posts][select][title]=true
}

export const getUrlFromQueryString = (path, queryString) => {
  const apiURL = process.env.NEXT_PUBLIC_NEXT_API_URL  // http://localhost:3000/api no trailing slash 
  // path // no trailing slash 
  return `${apiURL}/${path}?${queryString}`
}


export const parseQuery = (queryString, options={}) => {  
  const parsedQuery = qs.parse(queryString, options);
  const query = fixQueryTypes(parsedQuery)
  return query;
  //  DO not catch errors here, instead catch on upper level. 
}


export const stringifyQuery = (query, options={ encode: false }) => {
  try {
    return qs.stringify(query, options);
  }
  catch (error) {
    console.error(`stringifyQuery error: ${error}`)
    return null
  }
}

// NEW FUNCTION 

const fixQueryTypes = (query, modelName=null) => { 
  // THIS IS A MAIN FIXING FUNCTION 
  // USES OTHER CUSTOM FUNCTIONS 
  
  if (Array.isArray(query)) return query?.map(x => fixQueryTypes(x))

  const { skip, take, orderBy, select, where, ...rest } = query
  // if (Array.isArray(orderBy)) return orderBy?.map(x => fixQueryTypes(x))

  let queryFixed = {}
  
  // skip and take - pagination
  if (skip) queryFixed.skip = parseInt(skip)
  if (take) queryFixed.take = parseInt(take)  


  // orderBy
  queryFixed.orderBy = orderBy

  // select 
  if (select) {
    let newSelect = {}
    for (const [field, value] of Object.entries(select)) {
      if (typeof value === 'object') {
        newSelect[field] = fixQueryTypes(value)
      } else {
        newSelect[field] = convertSelectItem(field, value)      
      }
    }
    queryFixed.select = newSelect
  }

  // where
  if (where) {
    let newWhere = {}
    
    for (const [field, value] of Object.entries(where)) {
      if (typeof value === 'object') {
        newWhere[field] = fixQueryTypes(value)
      } else {
        newWhere[field] = convertWhereItem(field, value)      
      }
    }
    queryFixed.where = newWhere
  }
  
  // REST  
  if (rest) {
    let newRest = {}
    for (const [field, value] of Object.entries(rest)) {
      if (typeof value === 'object') {
        newRest[field] = fixQueryTypes(value)
      } else {
        newRest[field] = convertWhereItem(field, value)  // make it convert generic      
      }
    }
    queryFixed = { ...queryFixed, ...newRest }
  }

  return queryFixed
}


const convertSelectItem = (field, value) => {  
  if (value === '') return null  
  if (value === null) return null
  if (value.toString() === 'true') return true 
  if (value.toString() === 'false') return false
  return null  // should not happen  
}


const convertWhereItem = (field, value) => {  
  if (value === '') return null  
  if (value === null) return null
  if (value.toString() === 'true') return true 
  if (value.toString() === 'false') return false

  // 
  if (field === 'id') return parseInt(value)
  if (field.includes('_id')) return parseInt(value)
  if (field.includes('count_')) return parseInt(value)
  if (!isNaN(value) && value.toString().indexOf('.') !== -1) return parseFloat(value)
  if (!isNaN(value)) return parseInt(value) 
  
  return value
}



